(() => {
  // hamburger menu
  const hamburger = document.querySelector('.hamburger_menu');
  const slideMenu = document.querySelector('.slide_menu');

  if (hamburger && slideMenu) {
    hamburger.addEventListener('click', function () {
      this.classList.toggle('active');
      slideMenu.classList.toggle('active');
      document.body.classList.toggle('no-scroll');
    });
  }

  // smoothScroll
  const smoothScroll = () => {
    const elms = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
    for (const elm of elms) {
      const href = elm.getAttribute('href');
      if (!href) continue;

      if (href === '#') {
        elm.addEventListener('click', (event) => {
          event.preventDefault();
          scroll({ top: 0, behavior: 'smooth' });
        });
      } else {
        const target = document.querySelector(href);
        if (target) {
          elm.addEventListener('click', (event) => {
            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth' });
          });
        }
      }
    }
  };
  smoothScroll();

  // .acd_block height調整
  const setAcdBlockHeights = (): void => {
    const sections = document.querySelectorAll<HTMLElement>('.acd_section');

    sections.forEach((section) => {
      const blocks = Array.from(
        section.querySelectorAll<HTMLElement>('.acd_block'),
      );
      if (!blocks.length) return;

      blocks.forEach((b) => {
        b.style.height = '';
      });

      const rows: Record<number, HTMLElement[]> = {};

      blocks.forEach((block) => {
        const top = block.offsetTop;
        if (!rows[top]) {
          rows[top] = [];
        }
        rows[top].push(block);
      });

      Object.values(rows).forEach((rowBlocks) => {
        const maxHeight = Math.max(
          ...rowBlocks.map((b) => b.offsetHeight),
        );
        rowBlocks.forEach((b) => {
          b.style.height = `${maxHeight}px`;
        });
      });
    });
  };

  window.addEventListener('load', setAcdBlockHeights);
  let acdResizeTimer: number | undefined;
  window.addEventListener('resize', () => {
    if (acdResizeTimer !== undefined) {
      clearTimeout(acdResizeTimer);
    }
    acdResizeTimer = window.setTimeout(setAcdBlockHeights, 200);
  });
})();


(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // すべての .hbg_li を取得
    var items = document.querySelectorAll('.hbg_li');

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        // a1 / a2 / a3 / a4 などの識別クラスを取得
        var aClass = null;
        item.classList.forEach(function(c) {
          if (/^a\d$/.test(c)) {
            aClass = c;
          }
        });

        if (!aClass) {
          return; // 識別クラスが無ければ何もしない
        }

        // 対応する plus と acd を取得
        var plus = document.querySelector('.plus.' + aClass);
        var acd  = document.querySelector('.acd.' + aClass);

        // .open のトグル
        if (plus) {
          plus.classList.toggle('open');
        }
        if (acd) {
          acd.classList.toggle('open');
        }
      });
    });
  });
})();


(() => {
  const jq: any =
    (window as any).jQuery || (window as any).$;

  if (!jq) {
    return;
  }

  jq(() => {
    jq('.pagetop').on('click', (e: any) => {
      e.preventDefault();

      // ▼ ページトップへスクロール
      jq('html, body').animate({ scrollTop: 0 }, 500);

      // ▼ ドローンのアニメーション処理
      const $drone = jq('.pagetop_drone');
      if ($drone.length > 0) {
        const rect = ($drone[0] as HTMLElement).getBoundingClientRect();

        // 固定用スタイルを付与
        $drone.css({
          position: 'fixed',
          left: `${rect.left}px`,
          top: `${rect.top}px`,
          width: `${rect.width}px`,
          height: `${rect.height}px`,
          zIndex: 9999
        });

        // 上昇しながらフェードアウト
        $drone.animate(
          {
            top: `${rect.top - 100}px`,
            opacity: 0
          },
          500,
          () => {
            $drone.removeAttr('style');
          }
        );
      }
    });
  });
})();

